import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Version} from './version.model';

@Injectable({
	providedIn: 'root'
})
export class NouvelleVersionDisponibleService {

	versionCourante: Version;
	// Subject auquel les composants peuvent souscrire pour écouter cet évènement, via getVersion()
	private versionMiseAJour$: Subject<Version>;

	constructor() {
		this.versionMiseAJour$ = new Subject<Version>();
	}

	/**
	 * Vérifie si la version de l'application a été modifiée. Si oui notification par évènement
	 *
	 * @param nouvelleVersion la version à vérifier
	 */
	verifierVersion(nouvelleVersion: Version) {
		if (nouvelleVersion.estPertinente()) {
			// Si on a déjà une version courante et que celle-ci n'est pas la même que la nouvelle, on notifie les observers
			if (this.versionCourante && this.versionCourante.versionDifferente(nouvelleVersion)) {
				this.versionMiseAJour$.next(nouvelleVersion);
			}
			this.versionCourante = nouvelleVersion;
		}
	}

	/**
	 * Retourne l'observable des changements de version
	 */
	getVersion(): Observable<Version> {
		return this.versionMiseAJour$.asObservable();
	}
}
